import React, { useState } from 'react';
import Logo from './../asset/file.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faX } from '@fortawesome/free-solid-svg-icons';

export default function Navbar() {
  const [openBasic, setOpenBasic] = useState(false);

  return (
    <div
      className='bg-light w-100 d-block d-lg-flex d-xl-flex d-xxl-flex align-items-center justify-content-start px-4 py-2 position-relative'
      id='navbar'
      style={{ height: "8%" }}
    >
      <img src={Logo} alt={"werfen"} className='me-auto' style={{ height: "4em" }} />
      <FontAwesomeIcon
        icon={openBasic ? faX : faBars}
        className='position-absolute top-50 end-0 translate-middle mx-3 fs-3 cursor d-lg-none d-xl-none d-xxl-none'
        onClick={() => setOpenBasic((p) => !p)}
      />
      <div className='w-50 d-none d-lg-flex d-xl-flex d-xxl-flex justify-content-end'>
        <a href='#vision' className='mx-3 theme-color fw-bold fs-5' id='navLink'>Vision</a>
        <a href='#mission' className='mx-3 theme-color fw-bold fs-5' id='navLink'>Mission</a>
        <a href='#services' className='mx-3 theme-color fw-bold fs-5' id='navLink'>Services</a>
        <a href='#about' className='mx-3 theme-color fw-bold fs-5' id='navLink'>About</a>
      </div>

      <div className='w-100 bg-light flex-column d-lg-none d-xl-none d-xxl-none justify-content-center py-4 mx-0 position-absolute start-0 fadenav'
        style={{ zIndex: 99999, display: openBasic ? "flex" : "none" }}>
        <a href='#vision' className='mx-3 theme-color text-center fw-bold fs-5' id='navLink'>Vision</a><br></br>
        <a href='#mission' className='mx-3 theme-color text-center fw-bold fs-5' id='navLink'>Mission</a><br></br>
        <a href='#services' className='mx-3 theme-color text-center fw-bold fs-5' id='navLink'>Services</a><br></br>
        <a href='#about' className='mx-3 theme-color text-center fw-bold fs-5' id='navLink'>About</a>
      </div>
    </div>
  )
}